import AreaContainer from "../AreaContainer";
import { useKeyInfomation } from "../hooks/useKeyInfomation";
import InfomationSection from "./InfomationSection";
import styles from './keyInfro.module.css';
import globalStyles from '../result.module.css';

interface Props{
    features:any
}
interface Row{
    title:string,
    value:string
}

const KeyInfomation = ({features}: Props) => {
    let { keyInfo } = useKeyInfomation(features);
    
    if(keyInfo && keyInfo.length == 0) return null;
    if(keyInfo.length == 0) return null;

    return <AreaContainer area="key-infomation" style={null} extraClass={null}>
        
        <div className={styles.InfomationWrapper}>
            <h2 className={globalStyles.subTitleText}>Key Information</h2>
            <InfomationSection features={features} allowedFeatures={[
                'anchor_tenants',
                'ownership',
                'viewing',
                'legal',
                'num_units',
            ]} title={null} />
            <InfomationSection features={features} allowedFeatures={[
                'parking',
                'car_park',
                'parking_spaces',
                'nearest_airport',
                'nearest_road_link',
                'nearest_train_station',
                'nearest_underground',
                'transit_zone'
            ]} title="Travel"/>
            <InfomationSection features={features} allowedFeatures={[
                'max_people',
                'min_people',
                'total_workstations',
            ]} title="Business Space"/>
            <InfomationSection features={features} allowedFeatures={[
                'additional',
                'available_space',
                'design_life',
                'design_type',
                'goods_lift_weight',
                'passenger_lift_weight',
                'history',
                'leisure_facilities',
                'number_of_floors',
                'occupancy_levels',
                'total_size',
                'terms'
            ]} title="Further Infomation"/>
        </div>
    </AreaContainer>
};

export default KeyInfomation;
